import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import useQueryRecruiterCountByDate from "./useQueryRecruiterCountByDate.js";
import useTranslationAdmin from "../useTranslationAdmin.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import PageSubtitle from "../../common/widgets/PageSubtitle.js";
import RecruiterLineChart from "./CountLineChart.js";

export default function RecruiterCountByDateItem(props) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "RecruiterCountByDateItem");

  const { data, loading, errors } = useQueryRecruiterCountByDate();

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <div className="RecruiterCountByDateItem">
            <PageSubtitle
              colTitle={t("admin:admin_dashboard_recruiters_count_by_date_title")}
            />
            <Row>
              <Col>
                <RecruiterLineChart data={data }/>
              </Col>
            </Row>
          </div>
        )}
      />
    </HorizontalLoader>
  );
}
